import { useState } from "react";
import PageHeader from "../-components/PageHeader";
import Seo from "components/Seo";
import WarehouseForm, { WarehouseFormState } from "./WarehouseForm";

export default function ConsoleWarehouseCreate() {
    const [form, setForm] = useState<WarehouseFormState>({
        warehouse_no: null,
        port_name: "",
        name: "",
        driver_no: "",
        post: "",
        address: "",
        addressDetail: "",
    });

    return (
        <>
            <Seo type="console" pageTitle="입고지 관리" />
            <div className="flex-1 flex flex-col overflow-hidden max-h-[100dvh]">
                <PageHeader category="고객서비스" title="입고지 등록" />
                <div className="flex-1 bg-[#F7F6FB] flex overflow-hidden">
                    <div className="px-[40px] py-[28px] w-full overflow-auto">
                        <div className="bg-white rounded-[20px] py-[36px] px-[40px] min-w-[800px]">
                            <WarehouseForm form={form} setForm={setForm} />
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}
